import { useState, useEffect, useRef } from "react";
import Translator from "../../classes/Translator/Translator";
import { useHistory } from "react-router-dom";
import MFAService from "./MFA.service";

const MFALogic = () => {
  const { translator } = Translator();
  const history = useHistory();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [counter, setCounter] = useState(45);
  const [canResend, setCanResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState(null);
  const inputRefs = useRef([]);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);
    if (element.value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();
    if (/^\d{1,6}$/.test(pasteData)) {
      const pasteArray = pasteData.split("");
      const newOtp = [...otp];
      pasteArray.forEach((char, idx) => {
        if (idx < newOtp.length) {
          newOtp[idx] = char;
        }
      });
      setOtp(newOtp);
      const lastIndex = pasteArray.length - 1;
      if (lastIndex < inputRefs.current.length) {
        inputRefs.current[lastIndex].focus();
      }
    }
  };

  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => {
        setCounter((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [counter]);

  const handleResendClick = async () => {
    if (!canResend) return;
    try {
      setLoading(true);
      const email = localStorage.getItem("mfa_email");
      const session = localStorage.getItem("mfa_session");
      if (!email || !session) {
        setResendMessage("Sesión inválida. Vuelve a iniciar sesión.");
        setTimeout(() => setResendMessage(null), 4000);
        return;
      }
      const response = await MFAService().resend({ email, session });
      if (response instanceof Error || (response && response.error)) {
        setResendMessage("No se pudo reenviar el código. Intenta de nuevo.");
        setTimeout(() => setResendMessage(null), 4000);
        return;
      }
      if (response && response.session) {
        localStorage.setItem("mfa_session", response.session);
        setResendMessage("Se ha reenviado un nuevo código. Session actualizada.");
      } else {
        setResendMessage("Se ha reenviado un nuevo código.");
      }
      setCounter(45);
      setCanResend(false);
      setTimeout(() => setResendMessage(null), 5000);
    } catch (err) {
      console.error("Error en resend:", err);
      setResendMessage("Error reenviando código. Intenta nuevamente.");
      setTimeout(() => setResendMessage(null), 5000);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async () => {
    try {
      setLoading(true);
      const email = localStorage.getItem("mfa_email");
      const session = localStorage.getItem("mfa_session");
      const code = otp.join("");
      if (!email || !session) {
        console.log("Sesión MFA inválida, vuelve a iniciar sesión.");
        return;
      }
      await MFAService().verify({ email, session, code });
      history.push("/dashboard");
    } catch (error) {
      console.error("error:", error);
      console.log("Codigo incorrecto o sesión inválida");
    } finally {
      setLoading(false);
    }
  };

  return {
    translator,
    otp,
    inputRefs,
    counter,
    canResend,
    loading,
    resendMessage,
    handleChange,
    handleKeyDown,
    handlePaste,
    handleResendClick,
    handleVerify,
  };
};

export default MFALogic;
